import {
  NameInput,
  Address1Input,
  Address2Input,
  CityInput,
  StateInput,
  ZipInput,
} from "./LocationInputs";
import { AddressSuggestionCard } from "./AddressSuggestionCard";
import type { AddressValidationResult } from "@/app/_services/LocationService";

export const LocationForm = ({
  control,
  errors,
  step,
  geocodeResult,
  typedAddress,
  confirmLabel,
  onConfirm,
  onEdit,
  isSaving,
}: {
  control: any;
  errors: any;
  step: "form" | "confirm";
  geocodeResult: AddressValidationResult | null;
  typedAddress: string;
  confirmLabel: string;
  onConfirm: () => void;
  onEdit: () => void;
  isSaving: boolean;
}) => {
  return (
    <form id="location-form" onSubmit={(e) => e.preventDefault()}>
      <div className="grid gap-4">
        {step === "form" ? (
          <>
            <NameInput control={control} errors={errors} />
            <Address1Input control={control} errors={errors} />
            <Address2Input control={control} errors={errors} />
            <CityInput control={control} errors={errors} />
            <StateInput control={control} errors={errors} />
            <ZipInput control={control} errors={errors} />
          </>
        ) : (
          geocodeResult && (
            <AddressSuggestionCard
              geocodeResult={geocodeResult}
              typedAddress={typedAddress}
              confirmLabel={confirmLabel}
              onConfirm={onConfirm}
              onEdit={onEdit}
              isSaving={isSaving}
            />
          )
        )}
      </div>
    </form>
  );
};
